(function() {
	'use strict';
  
	var SAVE_NUDGE_THRESHOLD = 3;
	var SS_PRODUCTS_KEY = 'swym-wishlist-products';
	var SS_SHARE_URL_KEY = 'swym-share-url';
	// Translated CTA/state strings injected by the section (swym-wishlist-page.liquid)
	// so the merchant can localise them per market. Fallbacks keep the UI working if
	// the global is ever missing (e.g. JS loaded outside the section).
	var STRINGS = window.swymWishlistStrings || {};
	function t(key, fallback) {
	  return (STRINGS[key] != null && STRINGS[key] !== '') ? STRINGS[key] : fallback;
	}
	// Replace Shopify-style {{ placeholders }} in locale strings with runtime values.
	function tf(key, fallback, vars) {
	  var str = t(key, fallback);
	  if (!vars) return str;
	  return Object.keys(vars).reduce(function(out, name) {
		return out.replace(new RegExp('\\{\\{\\s*' + name + '\\s*\\}\\}', 'g'), vars[name]);
	  }, str);
	}
	function formatItemsCount(count) {
	  return tf('itemsCount', '({{ count }} items)', { count: count });
	}
	var productJSONCache = {};
	var shareButtonHandler = null;
	// Guards against overlapping renders (cached paint vs. authoritative
	// fetchLists paint). This is our only deviation from the Swym reference
	// implementation — see renderProducts.
	var renderToken = 0;
  
	function initWishlistPage(swat) {
	  // Use the SDK's built-in login check — this is the canonical way.
	  // Under the hood, Swym's Liquid snippet sets window.swymCustomerId
	  // from Shopify's {{ customer.id }} object. The SDK reads it on init.
	  var isLoggedIn = swat.platform.isLoggedIn();
	  var grid = document.getElementById('swym-wishlist-grid');
	  var loading = document.getElementById('swym-wishlist-loading');
	  var empty = document.getElementById('swym-wishlist-empty');
	  var countEl = document.getElementById('swym-wishlist-count');
  
	  if (!grid) return;
  
	  // Show login nudge for anonymous users
	  if (!isLoggedIn) {
		var loginNudge = document.getElementById('swym-login-nudge');
		if (loginNudge) loginNudge.style.display = '';
	  }
  
	  // Start renderProducts before swat.fetchLists resolves; both run in parallel.
	  var cachedRaw = sessionStorage.getItem(SS_PRODUCTS_KEY);
	  var cachedData = null;
	  if (cachedRaw) {
		try {
		  cachedData = JSON.parse(cachedRaw);
		  if (loading) loading.style.display = 'none';
		  renderProducts(swat, cachedData.lid, cachedData.products, grid, countEl, empty);
		  if (countEl) countEl.textContent = formatItemsCount(cachedData.products.length);
		  setupShareButton(swat, cachedData.lid, cachedData.products.length);
		} catch (e) {
		  sessionStorage.removeItem(SS_PRODUCTS_KEY);
		  cachedData = null;
		}
	  }
  
	  // fetchLists gives us the default list lid (needed for sharing) and its
	  // contents in one call — no separate swat.fetch needed on initial load.
	  swat.fetchLists({
		callbackFn: function(lists) {
		  if (loading) loading.style.display = 'none';
  
		  // Restore the previously-selected list from cache; fall back to lists[0].
		  var cachedLid = cachedData ? cachedData.lid : null;
		  var activeList = lists && lists.length
			? (cachedLid ? (lists.find(function(l) { return l.lid === cachedLid; }) || lists[0]) : lists[0])
			: null;
		  var lid = activeList ? activeList.lid : null;
		  var products = activeList ? (activeList.listcontents || []) : [];
  
		  // Always update cache and re-render from the authoritative API response
		  sessionStorage.setItem(SS_PRODUCTS_KEY, JSON.stringify({ lid: lid, products: products }));
  
		  // Always re-render from the authoritative response so stale cached cards
		  // are cleared — including when the list is now empty but the cached paint
		  // (or a bfcache restore) still showed items. Fixes the "empty message +
		  // leftover card" state after removing an item on another page.
		  renderProducts(swat, lid, products, grid, countEl, empty);
		  if (countEl) countEl.textContent = formatItemsCount(products.length);
		  if (products.length === 0) {
			setupShareButton(swat, lid, 0);
		  } else {
			showSaveNudge(swat, products.length);
			setupShareButton(swat, lid, products.length);
			sessionStorage.removeItem(SS_SHARE_URL_KEY);
		  }
  
		  // Always initialize the switcher so it's wired up regardless of cache hit
		  setupListSwitcher(swat, lists, lid, grid, countEl, empty);
  
		  // Re-render on wishlist changes — refetch all lists so the switcher
		  // reflects updated counts and any list that became empty / was deleted.
		  if (swat.evtLayer) {
			swat.evtLayer.addEventListener('sw:removedfromwishlist', function() {
			  swat.fetchLists({
				callbackFn: function(freshLists) {
				  // Preserve whichever list was active; fall back to the first remaining one.
				  var activeLid = sessionStorage.getItem(SS_PRODUCTS_KEY)
					? (JSON.parse(sessionStorage.getItem(SS_PRODUCTS_KEY)) || {}).lid
					: lid;
				  var activeList = freshLists && freshLists.length
					? (freshLists.find(function(l) { return l.lid === activeLid; }) || freshLists[0])
					: null;
				  var currentLid = activeList ? activeList.lid : null;
				  var updated = activeList ? (activeList.listcontents || []) : [];
				  var count = updated.length;
  
				  sessionStorage.setItem(SS_PRODUCTS_KEY, JSON.stringify({ lid: currentLid, products: updated }));
				  sessionStorage.removeItem(SS_SHARE_URL_KEY);
				  renderProducts(swat, currentLid, updated, grid, countEl, empty);
				  if (countEl) countEl.textContent = formatItemsCount(count);
				  setupShareButton(swat, currentLid, count);
				  setupListSwitcher(swat, freshLists || [], currentLid, grid, countEl, empty);
				}
			  });
			});
		  }
		},
		errorFn: function() {
		  if (loading) loading.style.display = 'none';
		}
	  });

	  // Back/forward-cache restores don't re-run init, so an item removed on
	  // another page (e.g. the PDP) would otherwise linger here. Re-reconcile
	  // against the server whenever the page is restored from bfcache.
	  window.addEventListener('pageshow', function(e) {
		if (e.persisted) reconcileWishlist(swat);
	  });
	}

	// Re-fetch the active list from the server and repaint. Used on bfcache
	// restore so the page reflects removals made elsewhere without a full reload.
	function reconcileWishlist(swat) {
	  var grid = document.getElementById('swym-wishlist-grid');
	  if (!grid) return;
	  var countEl = document.getElementById('swym-wishlist-count');
	  var empty = document.getElementById('swym-wishlist-empty');

	  var cachedLid = null;
	  var cachedRaw = sessionStorage.getItem(SS_PRODUCTS_KEY);
	  if (cachedRaw) {
		try { cachedLid = (JSON.parse(cachedRaw) || {}).lid; } catch (e) {}
	  }

	  swat.fetchLists({
		callbackFn: function(lists) {
		  var activeList = lists && lists.length
			? (cachedLid ? (lists.find(function(l) { return l.lid === cachedLid; }) || lists[0]) : lists[0])
			: null;
		  var lid = activeList ? activeList.lid : null;
		  var products = activeList ? (activeList.listcontents || []) : [];

		  sessionStorage.setItem(SS_PRODUCTS_KEY, JSON.stringify({ lid: lid, products: products }));
		  renderProducts(swat, lid, products, grid, countEl, empty);
		  if (countEl) countEl.textContent = formatItemsCount(products.length);
		  setupShareButton(swat, lid, products.length);
		},
		errorFn: function() {}
	  });
	}
  
	// Recipient view for a shared wishlist link. Follows Swym's "Share via link"
	// docs: the sharer marks the list public + generates the URL (see
	// openShareModal), and this page reads the `lid`/`hkey` from that URL and
	// calls swat.fetchListDetails({ lid }) to fetch and render the public list
	// read-only. https://developers.getswym.com/docs/share-via-link
	function initSharedWishlistPage(swat) {
	  var grid = document.getElementById('swym-wishlist-grid');
	  var loading = document.getElementById('swym-wishlist-loading');
	  var empty = document.getElementById('swym-wishlist-empty');
	  var countEl = document.getElementById('swym-wishlist-count');

	  if (!grid) return;

	  var params = new URLSearchParams(window.location.search);
	  // Swym share links pass both; either is the public list id.
	  var lid = params.get('lid') || params.get('hkey');

	  // No list id in the URL — nothing to fetch, show the empty/invalid state.
	  if (!lid) {
		if (loading) loading.style.display = 'none';
		if (empty) empty.style.display = 'block';
		grid.setAttribute('aria-busy', 'false');
		return;
	  }

	  swat.fetchListDetails(
		{ lid: lid },
		function(listDetails) {
		  if (loading) loading.style.display = 'none';
		  var list = listDetails && listDetails.list;
		  var products = (listDetails && listDetails.items) || (list && list.listcontents) || [];
		  if (list && list.lname) setWishlistTitle(list.lname);
		  renderProducts(swat, lid, products, grid, countEl, empty, { readOnly: true });
		  if (countEl) countEl.textContent = formatItemsCount(products.length);
		},
		function(error) {
		  // Invalid/expired link or a list that's no longer public.
		  if (loading) loading.style.display = 'none';
		  if (empty) empty.style.display = 'block';
		  grid.setAttribute('aria-busy', 'false');
		  console.warn('Swym fetchListDetails failed', error);
		}
	  );
	}

	// True on the recipient landing page. Prefer the Liquid flag; fall back to
	// path + query so a missing script assignment cannot silently show the
	// visitor's own (empty) wishlist instead of the shared list.
	function isSharedWishlistPage() {
	  if (window.swymWishlistPageMode === 'shared') return true;
	  try {
		var path = window.location.pathname || '';
		if (path.indexOf('/pages/swym-share-wishlist') === -1) return false;
		var params = new URLSearchParams(window.location.search);
		return !!(params.get('lid') || params.get('hkey'));
	  } catch (e) {
		return false;
	  }
	}

	function showSaveNudge(swat, count) {
	  if (swat.platform.isLoggedIn()) return;
	  if (count < SAVE_NUDGE_THRESHOLD) return;
	  if (sessionStorage.getItem('swym-save-nudge-dismissed')) return;
  
	  var nudge = document.getElementById('swym-save-nudge');
	  if (!nudge) return;
  
	  var countSpan = document.getElementById('swym-save-nudge-count');
	  if (countSpan) countSpan.textContent = count;
	  nudge.style.display = '';
  
	  var dismiss = document.getElementById('swym-save-nudge-dismiss');
	  if (dismiss) {
		dismiss.addEventListener('click', function() {
		  nudge.style.display = 'none';
		  sessionStorage.setItem('swym-save-nudge-dismissed', 'true');
		});
	  }
	}
  
	async function renderProducts(swat, lid, products, container, countEl, emptyEl, options) {
	  // `readOnly` renders the recipient view of a shared list (see the shared
	  // wishlist page): no remove-heart control, but the Add To Bag / Shop the Set
	  // CTA stays so the visitor can buy the items as a gift.
	  var readOnly = !!(options && options.readOnly);
	  // Guard against overlapping renders. On load, the cached-data render and the
	  // authoritative fetchLists render run in parallel, and each awaits product
	  // JSON before appending. Without a generation token both appends land and
	  // every item shows twice. Only the most recent render is allowed to paint.
	  var myToken = ++renderToken;
	  container.setAttribute('aria-busy', 'true');
  
	  if (!products || products.length === 0) {
		container.innerHTML = '';
		if (emptyEl) emptyEl.style.display = 'block';
		container.setAttribute('aria-busy', 'false');
		return;
	  }
  
	  if (emptyEl) emptyEl.style.display = 'none';
  
	  // Fetch live product data from Shopify in parallel before building any card.
	  // Results are cached by variant ID for the lifetime of the page so list switches
	  // don't re-fetch products already loaded. Cache is cleared on page refresh.
	  var shopifyData = await Promise.all(products.map(function(product) {
		var key = String(product.epi);
		if (productJSONCache[key]) return Promise.resolve(productJSONCache[key]);
		return fetchProductJSON(product.du)
		  .then(function(data) { productJSONCache[key] = data; return data; })
		  .catch(function() { return null; });
	  }));
  
	  // A newer render started while we awaited product data — abandon this stale
	  // pass so we don't append a duplicate set of cards.
	  if (myToken !== renderToken) return;
  
	  // Clear immediately before appending (not at the top) so a concurrent render
	  // can't slot its cards in between our clear and our append.
	  container.innerHTML = '';
	  
	  // Card markup mirrors the collection product card (product-item.vue /
	  // product-tags.vue) so it can reuse the collection class names. The matching
	  // styles live in swym-wishlist-page.css (scoped to #swym-wishlist-page).
	  products.forEach(function(product, index) {
		var shopifyProduct = shopifyData[index];
		var variant = shopifyProduct && shopifyProduct.variants
		  ? shopifyProduct.variants.find(function(v) { return String(v.id) === String(product.epi); })
		  : null;

		// Match the collection cards: a product counts as available if ANY variant
		// is in stock (shopifyProduct.available), not just the saved variant. A
		// shopper's saved size may be sold out while the product is still buyable,
		// and the quick-add overlay lets them pick another size.
		var inStock = shopifyProduct
		  ? shopifyProduct.available
		  : product.stk !== 0;
		var isSoldOut = !inStock;
		var priceCents = variant ? variant.price : product.pr;
		var compareCents = variant ? variant.compare_at_price : 0;
		var isSale = compareCents && compareCents > priceCents;

		var rawTitle = (shopifyProduct && shopifyProduct.title) || product.dt || t('productFallback', 'Product');
		var title = esc(rawTitle);
		var href = esc(shopifyProduct && shopifyProduct.url || product.du || '#');

		// Sets can't be added via the quick-add overlay (they have no single
		// variant to pick), so their buy button links straight to the set page.
		var isSet = rawTitle.indexOf('Set: ') !== -1;
		var buyAsLink = isSet && !isSoldOut;

		var images = (shopifyProduct && shopifyProduct.images) || [];
		var firstImage = esc(images[0] || (shopifyProduct && shopifyProduct.featured_image) || product.iu || (window.themeJs && window.themeJs.noImage) || '');
		var secondImage = images.length > 1 ? esc(images[1]) : '';

		var badges = resolveBadges(shopifyProduct, isSoldOut, isSale);

		// formatMoneyVat returns the shop money format, which includes HTML
		// (e.g. <span class="money">…</span>), so it must be inserted as HTML.
		// Sets hide their price (set pricing is shown on the set page) but keep the
		// wrapper — the --hidden modifier only toggles visibility so nothing shifts.
		var priceHiddenClass = isSet ? ' product-grid-item__price--hidden' : '';
		var priceHtml = isSale
		  ? '<p class="sale-item' + priceHiddenClass + '"><span class="price-wrapper visible">' +
			  '<span class="sale-item">' + formatMoneyVat(priceCents) + '</span>' + 
			  '<s class="grey-text">' + formatMoneyVat(compareCents) + '</s>' +
			'</span></p>'
		  : '<p class="grey-text' + priceHiddenClass + '"><span class="price-wrapper visible">' +
			  '<span>' + formatMoneyVat(priceCents) + '</span>' +
			'</span></p>';

		var column = document.createElement('div');
		column.className = 'product-grid-item-column col l6 m12 s6' + (isSoldOut ? ' sold-out' : '');
		column.innerHTML =
		  '<a href="' + href + '" class="product-grid-item collection__product-grid' + (isSoldOut ? ' product-grid-item--sold-out' : '') + '">' +
			'<div class="product-grid-item__images-wrap">' +
			  (readOnly ? '' :
				'<button type="button" class="product-grid-item__wishlist swym-added" aria-label="' + esc(tf('removeFromWishlistAria', 'Remove {{ title }} from wishlist', { title: rawTitle })) + '">' +
				  '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
					'<path d="M20.42 4.58a5.4 5.4 0 00-7.65 0l-.77.78-.77-.78a5.4 5.4 0 00-7.65 0C1.46 6.7 1.33 10.28 4 13l8 8 8-8c2.67-2.72 2.54-6.3.42-8.42z"/>' +
				  '</svg>' +
				'</button>') +
			  renderTags(badges, 'Left') +
			  '<div class="product-grid-item__images">' +
				'<img' + (secondImage ? ' class="first-image"' : '') + ' alt="' + title + '" src="' + firstImage + '" loading="lazy">' +
				(secondImage ? '<img class="second-image" alt="' + title + '" src="' + secondImage + '" loading="lazy">' : '') +
			  '</div>' +
			'</div>' +
			'<div class="text-wrapper">' +
			  '<div class="product-grid-item__content">' +
				renderTags(badges, 'Below') +
				'<p class="body-2 product-grid-item__title">' + title + '</p>' +
				priceHtml +
			  '</div>' +
			'</div>' +
		  '</a>' +
		  (buyAsLink
			? '<a href="' + href + '" class="button button--block wishlist__add-to-bag"' +
				' aria-label="' + esc(tf('shopTheSetAria', 'Shop the {{ title }} set', { title: rawTitle })) + '">' + t('shopTheSet', 'Shop the Set') + '</a>'
			: '<button type="button" class="button button--block wishlist__add-to-bag"' + (isSoldOut ? ' disabled' : '') +
				' aria-label="' + esc(isSoldOut
				  ? tf('outOfStockAria', '{{ title }} is out of stock', { title: rawTitle })
				  : tf('addToBagAria', 'Add {{ title }} to bag', { title: rawTitle })) + '">' +
				(isSoldOut ? t('soldOut', 'Out of Stock') : t('addToBag', 'Add To Bag')) +
			  '</button>');

		var addBtn = column.querySelector('.wishlist__add-to-bag');
		var wishlistBtn = column.querySelector('.product-grid-item__wishlist');

		// The heart lives inside the card link and acts as the remove control on the
		// wishlist page (every item is already saved, so it renders filled/swym-added).
		// It's omitted in read-only (shared) mode, so guard for its absence.
		if (wishlistBtn) {
		  wishlistBtn.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			swat.deleteFromList(
			  lid,
			  { epi: product.epi, empi: product.empi, du: product.du },
			  function() {
				column.remove();
				var remaining = container.querySelectorAll('.product-grid-item-column');
				if (countEl) countEl.textContent = formatItemsCount(remaining.length);
				if (remaining.length === 0 && emptyEl) emptyEl.style.display = 'block';
			  },
			  function(err) { console.error('deleteFromList error', err); }
			);
		  });
		}

		if (!isSoldOut && !buyAsLink) {
		  // Fallback: add the saved variant straight to cart. Only used if the
		  // shared quick-add modal isn't available (e.g. frame.js not loaded).
		  var directAdd = function() {
			addBtn.textContent = t('adding', 'Adding…');
			addBtn.setAttribute('aria-label', tf('addingToBagAria', 'Adding {{ title }} to bag', { title: rawTitle }));
			addBtn.disabled = true;
			fetch('/cart/add.js', {
			  method: 'POST',
			  headers: { 'Content-Type': 'application/json' },
			  body: JSON.stringify({ items: [{ id: Number(product.epi), quantity: 1 }] })
			})
			.then(function(response) {
			  if (response.ok) {
				addBtn.textContent = t('added', 'Added!');
				addBtn.setAttribute('aria-label', tf('addedToBagAria', '{{ title }} added to bag', { title: rawTitle }));
				setTimeout(function() {
				  addBtn.textContent = t('addToBag', 'Add To Bag');
				  addBtn.setAttribute('aria-label', tf('addToBagAria', 'Add {{ title }} to bag', { title: rawTitle }));
				  addBtn.disabled = false;
				}, 2000);
			  } else {
				addBtn.textContent = t('error', 'Error');
				addBtn.setAttribute('aria-label', tf('failedAddAria', 'Failed to add {{ title }} to bag', { title: rawTitle }));
				addBtn.disabled = false;
			  }
			})
			.catch(function() {
			  addBtn.textContent = t('error', 'Error');
			  addBtn.setAttribute('aria-label', tf('failedAddAria', 'Failed to add {{ title }} to bag', { title: rawTitle }));
			  addBtn.disabled = false;
			});
		  };

		  addBtn.addEventListener('click', function() {
			// Open the shared quick-add modal so the shopper selects size/variant,
			// matching the collection cards' behaviour.
			var handle = productHandle(shopifyProduct, product);
			if (handle && window.Frame && typeof window.Frame.openQuickAdd === 'function') {
			  var opened = window.Frame.openQuickAdd(handle);
			  if (opened && typeof opened.catch === 'function') opened.catch(directAdd);
			  return;
			}
			directAdd();
		  });
		}

		container.appendChild(column);
	  });
	  container.setAttribute('aria-busy', 'false');
	}
  
	function bindShareUrlButtons(modal, copyBtn, url, swat, lid) {
	  var urlInput = document.getElementById('swym-share-url-input');
	  if (urlInput) urlInput.value = url;
	  if (copyBtn) {
		copyBtn.disabled = false;
		var freshCopy = copyBtn.cloneNode(true);
		copyBtn.parentNode.replaceChild(freshCopy, copyBtn);
		freshCopy.addEventListener('click', function() { handleCopyLink(url); });
	  }
	  var nativeShareBtn = modal.querySelector('#swym-share-native-btn');
	  if (nativeShareBtn) {
		var freshShare = nativeShareBtn.cloneNode(true);
		nativeShareBtn.parentNode.replaceChild(freshShare, nativeShareBtn);
		freshShare.addEventListener('click', function() { handleNativeShare(url); });
	  }
	}
  
	function setupShareButton(swat, lid, productCount) {
	  var btn = document.getElementById('swym-share-btn');
	  if (!btn || !lid) return;
  
	  if (productCount === 0) {
		btn.style.display = 'none';
		return;
	  }
	  btn.style.display = '';
  
	  // Remove the previous listener by reference rather than replacing the node.
	  // Replacing the node triggers Swym's SDK button-watcher, which re-attaches its
	  // own listener and results in two openShareModal calls per click.
	  if (shareButtonHandler) btn.removeEventListener('click', shareButtonHandler);
	  shareButtonHandler = function() { openShareModal(swat, lid); };
	  btn.addEventListener('click', shareButtonHandler);
	}
  
	function openShareModal(swat, lid) {
	  var modal = document.getElementById('swym-share-modal');
	  if (!modal) return;
  
	  // Reset form fields and feedback
	  var nameInput = document.getElementById('swym-share-name-input');
	  var emailInput = document.getElementById('swym-share-email-input');
	  var noteInput = document.getElementById('swym-share-note-input');
	  var copyBtn = document.getElementById('swym-share-copy-btn');
	  var urlInput = document.getElementById('swym-share-url-input');
	  if (nameInput) nameInput.value = '';
	  if (emailInput) emailInput.value = '';
	  if (noteInput) noteInput.value = '';
	  if (urlInput) urlInput.value = '';
	  if (copyBtn) copyBtn.disabled = true;
	  modal.querySelectorAll('[id$="-feedback"]').forEach(function(el) { el.style.display = 'none'; });
  
	  modal.style.display = '';
	  document.body.style.overflow = 'hidden';
	  if (nameInput) nameInput.focus();
  
	  var cachedShareUrl = sessionStorage.getItem(SS_SHARE_URL_KEY);
	  if (cachedShareUrl) {
		bindShareUrlButtons(modal, copyBtn, cachedShareUrl, swat, lid);
	  } else {
		// Must mark the list public before a shareable URL can be generated
		swat.markListPublic(lid, function() {
		  swat.generateSharedListURL(lid, function(url) {
			sessionStorage.setItem(SS_SHARE_URL_KEY, url);
			bindShareUrlButtons(modal, copyBtn, url, swat, lid);
		  });
		}, function() {
		  if (copyBtn) copyBtn.disabled = true;
		});
	  }
  
	  // Bind email button
	  var emailBtn = document.getElementById('swym-share-email-btn');
	  if (emailBtn) {
		var freshEmail = emailBtn.cloneNode(true);
		emailBtn.parentNode.replaceChild(freshEmail, emailBtn);
		freshEmail.addEventListener('click', function() { handleEmailShare(swat, lid); });
	  }
  
	  // Close — button, overlay click, Escape key
	  var closeBtn = document.getElementById('swym-share-modal-close');
	  var overlay = document.getElementById('swym-share-modal-overlay');
	  if (closeBtn) {
		var freshClose = closeBtn.cloneNode(true);
		closeBtn.parentNode.replaceChild(freshClose, closeBtn);
		freshClose.addEventListener('click', closeShareModal);
	  }
	  if (overlay) {
		var freshOverlay = overlay.cloneNode(true);
		overlay.parentNode.replaceChild(freshOverlay, overlay);
		freshOverlay.addEventListener('click', closeShareModal);
	  }
	  document.addEventListener('keydown', handleShareModalKeydown);
	}
  
	function handleShareModalKeydown(e) {
	  if (e.key === 'Escape') {
		closeShareModal();
		return;
	  }
	  if (e.key !== 'Tab') return;
  
	  var modal = document.getElementById('swym-share-modal-content');
	  if (!modal) return;
	  var focusable = Array.prototype.slice.call(
		modal.querySelectorAll('a[href],button:not([disabled]),input,textarea,select,[tabindex]:not([tabindex="-1"])')
	  ).filter(function(el) { return !el.disabled && el.offsetParent !== null; });
	  if (!focusable.length) return;
  
	  var first = focusable[0];
	  var last = focusable[focusable.length - 1];
	  if (e.shiftKey) {
		if (document.activeElement === first) { e.preventDefault(); last.focus(); }
	  } else {
		if (document.activeElement === last) { e.preventDefault(); first.focus(); }
	  }
	}
  
	function closeShareModal() {
	  var modal = document.getElementById('swym-share-modal');
	  if (modal) modal.style.display = 'none';
	  document.body.style.overflow = '';
	  document.removeEventListener('keydown', handleShareModalKeydown);
	  var trigger = document.getElementById('swym-share-btn');
	  if (trigger) trigger.focus();
	}
  
	function handleCopyLink(url) {
	  var feedback = document.getElementById('swym-share-copy-feedback');
	  if (navigator.clipboard && navigator.clipboard.writeText) {
		navigator.clipboard.writeText(url).then(function() {
		  showModalFeedback(feedback);
		}).catch(function() {
		  fallbackCopy(url, feedback);
		});
	  } else {
		fallbackCopy(url, feedback);
	  }
	}
  
	function handleEmailShare(swat, lid) {
	  var nameInput = document.getElementById('swym-share-name-input');
	  var emailInput = document.getElementById('swym-share-email-input');
	  var noteInput = document.getElementById('swym-share-note-input');
	  var emailBtn = document.getElementById('swym-share-email-btn');
	  var feedback = document.getElementById('swym-share-email-feedback');
	  if (!emailInput) return;
  
	  var email = emailInput.value.trim();
	  if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
		emailInput.focus();
		return;
	  }
  
	  if (emailBtn) emailBtn.disabled = true;
	  swat.sendListViaEmail({
		toEmailId: email,
		note: noteInput ? noteInput.value.trim() : '',
		fromName: nameInput ? nameInput.value.trim() : '',
		lid: lid
	  }, function() {
		if (emailBtn) emailBtn.disabled = false;
		if (nameInput) nameInput.value = '';
		emailInput.value = '';
		if (noteInput) noteInput.value = '';
		showModalFeedback(feedback);
		setTimeout(closeShareModal, 1000);
	  }, function() {
		if (emailBtn) emailBtn.disabled = false;
	  });
	}
  
	// Single share entry point. On devices that support the Web Share API (mobile
	// Safari/Chrome) this opens the native OS share sheet — the generic iOS/Android
	// share options — letting the shopper pick any app. On desktop, where Web Share
	// is generally unavailable, we fall back to copying the wishlist link to the
	// clipboard (reusing the copy-link feedback).
	function handleNativeShare(url) {
	  if (navigator.share) {
		navigator.share({ title: t('nativeShareTitle', 'My Bluebella Wishlist'), url: url })
		  .then(function() { closeShareModal(); })
		  .catch(function() { /* user dismissed the share sheet — leave modal open */ });
		return;
	  }
	  handleCopyLink(url);
	}
  
	function showModalFeedback(el) {
	  if (!el) return;
	  el.style.display = '';
	  setTimeout(function() { el.style.display = 'none'; }, 2500);
	}
  
	function fallbackCopy(url, feedbackEl) {
	  var ta = document.createElement('textarea');
	  ta.value = url;
	  ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none;';
	  document.body.appendChild(ta);
	  ta.select();
	  try { document.execCommand('copy'); showModalFeedback(feedbackEl); } catch (e) {}
	  document.body.removeChild(ta);
	}
  
	// Matches the VAT multiplier the collection cards apply (product-price.vue) so
	// wishlist prices are identical to what the collection page shows.
	function getVatValue() {
	  var domain = window.themeJs && window.themeJs.store && window.themeJs.store.domain;
	  if (domain === 'bluebella-2.myshopify.com') return 1.2;
	  if (domain === 'bluebella-au.myshopify.com') return 1.1;
	  return 1;
	}

	function formatMoneyVat(priceInCents) {
	  var value = Number(priceInCents) * getVatValue();
	  var format = (window.themeJs && window.themeJs.moneyFormat) || '${{amount}}';
	  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
		return window.Shopify.formatMoney(value, format);
	  }
	  return (value / 100).toFixed(2);
	}

	// Mirrors product-item.vue loadProductBadges: derive badge objects from the
	// product tags (+ synthetic sold-out / sale tags) using the global badge config.
	function resolveBadges(shopifyProduct, isSoldOut, isSale) {
	  var defs = (window.themeJs && window.themeJs.productBadges) || [];
	  var tags = shopifyProduct && Array.isArray(shopifyProduct.tags) ? shopifyProduct.tags.slice() : [];
	  if (isSoldOut) tags.push('badge-sold-out');
	  if (isSale) tags.push('badge-for-sale');
	  return tags
		.filter(function(tag) { return String(tag).indexOf('badge-') !== -1; })
		.map(function(tag) { return defs.find(function(b) { return b.handle === tag; }) || {}; })
		.filter(function(b) { return b.title; })
		.map(function(b) { return b.align === 'Right' ? Object.assign({}, b, { align: 'Left' }) : b; });
	}

	function badgeInlineStyle(badge) {
	  var style = '';
	  if (badge.backgroundColor && badge.backgroundColor !== 'rgba(0,0,0,0)') style += 'background-color:' + badge.backgroundColor + ';';
	  if (badge.textColor) style += 'color:' + badge.textColor + ';';
	  if (badge.textColor === '') style += 'color:rgba(0,0,0,0);';
	  if (badge.image) style += 'background-image:url(' + badge.image + ');background-position:center;background-size:cover;';
	  return style;
	}

	// Mirrors product-tags.vue markup for a given badge position.
	function renderTags(badges, position) {
	  var filtered = badges.filter(function(b) { return b.align === position; });
	  // Always render the "Below" wrapper (even when empty) so its reserved
	  // min-height keeps every card the same height whether or not it has a badge.
	  if (!filtered.length && position !== 'Below') return '';
	  var items = filtered.map(function(b) {
		var cls = 'product-tag';
		if (b.image) cls += ' product-tag--has-image';
		if (!b.backgroundColor || b.backgroundColor === 'rgba(0,0,0,0)') cls += ' product-tag--no-background';
		return '<div class="' + cls + '"><span style="' + badgeInlineStyle(b) + '">' + esc(b.title) + '</span></div>';
	  }).join('');
	  return '<div class="product-tags product-tags--' + position.toLowerCase() + '">' + items + '</div>';
	}
  
	// Resolve a product handle from the Shopify product JSON, falling back to
	// parsing it out of the Swym item's product URL (du).
	function productHandle(shopifyProduct, product) {
	  if (shopifyProduct && shopifyProduct.handle) return shopifyProduct.handle;
	  if (product && product.du) {
		var parts = String(product.du).split('/products/');
		if (parts.length > 1) return parts[1].split('?')[0].split('/')[0];
	  }
	  return '';
	}

	function esc(str) {
	  return String(str)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
	}
  
	function fetchProductJSON(du) {
	  var parts = du.split('/products/');
	  if (parts.length < 2) return Promise.reject(new Error('invalid product URL'));
	  var url = window.location.origin + window.Shopify.routes.root + 'products/' + parts[1].split('?')[0] + '.js';
	  return fetch(url)
		.then(function(response) {
		  if (!response.ok) throw new Error('product fetch failed');
		  return response.json();
		});
	}
  
	function setWishlistTitle(name) {
	  var titleEl = document.getElementById('swym-wishlist-title');
	  if (titleEl) titleEl.textContent = name || t('myWishlist', 'My Wishlist');
	}
  
	function setupListSwitcher(swat, lists, activeLid, grid, countEl, emptyEl) {
	  var wrapper = document.getElementById('swym-list-switcher-wrapper');
	  var switcher = document.getElementById('swym-list-switcher');
	  if (!wrapper || !switcher) return;
  
	  // Hide the switcher for shoppers with only one list or when Collections is disabled.
	  if (!swat.isCollectionsEnabled() || lists.length < 2) {
		wrapper.style.display = 'none';
		return;
	  }
	  wrapper.style.display = '';
  
	  // Replace the node to clear any listener attached during a previous fetchLists call.
	  var fresh = switcher.cloneNode(false);
	  switcher.parentNode.replaceChild(fresh, switcher);
  
	  lists.forEach(function(list) {
		var option = document.createElement('option');
		option.value = list.lid;
		option.textContent = tf('listOption', '{{ name }} ({{ count }} items)', {
		  name: list.lname,
		  count: list.listcontents.length
		});
		if (list.lid === activeLid) option.selected = true;
		fresh.appendChild(option);
	  });
  
	  // Reflect the active list name in the page title on switcher setup.
	  var activeList = lists.find(function(l) { return l.lid === activeLid; });
	  if (activeList) setWishlistTitle(activeList.lname);
  
	  fresh.addEventListener('change', function() {
		var selected = lists.find(function(l) { return l.lid === fresh.value; });
		if (!selected) return;
		var products = selected.listcontents || [];
		sessionStorage.setItem(SS_PRODUCTS_KEY, JSON.stringify({ lid: selected.lid, products: products }));
		sessionStorage.removeItem(SS_SHARE_URL_KEY);
		var count = products.length;
		if (countEl) countEl.textContent = formatItemsCount(count);
		setWishlistTitle(selected.lname);
		setupShareButton(swat, selected.lid, count);
		renderProducts(swat, selected.lid, products, grid, countEl, emptyEl);
	  });
	}
  
	window.SwymCallbacks = window.SwymCallbacks || [];
	window.SwymCallbacks.push(function(swat) {
	  // Shared (recipient) pages must fetch by public lid — not the viewer's lists.
	  if (isSharedWishlistPage()) {
		initSharedWishlistPage(swat);
	  } else {
		initWishlistPage(swat);
	  }
	});
  })();